export const xjtypes = [
    {code:'1',name:'询比价'},
    {code:'2',name:'定向采购'},
    {code:'3',name:'竞争性磋商'},
]

export const noticeType = [
    {code:'1',name:'企业公告'},
]

// 项目类型
export const projectTypeOption = [
    {code:'1',name:'劳务分包'},
    {code:'2',name:'专业分包'},
    {code:'3',name:'物资采购'},
    {code:'4',name:'装备租赁'},
    {code:'5',name:'其他'},
]
